import { Chip, ChipProps } from '@mui/material';
import { FC } from 'react';

interface Props extends ChipProps {
  isBold?: boolean;
}

export const QcsChip: FC<Props> = ({ isBold, ...props }) => (
  <Chip size="small" {...props} sx={{ fontSize: '0.8rem', ...(isBold && { fontWeight: 600 }), ...props.sx }} />
);
